export const getScooter = (state) => state.scooter
